import { render, staticRenderFns } from "./SaleHistoryEventSentInfo.vue?vue&type=template&id=08a76ab4&scoped=true"
import script from "./SaleHistoryEventSentInfo.vue?vue&type=script&lang=ts"
export * from "./SaleHistoryEventSentInfo.vue?vue&type=script&lang=ts"
import style0 from "./SaleHistoryEventSentInfo.vue?vue&type=style&index=0&id=08a76ab4&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08a76ab4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('08a76ab4')) {
      api.createRecord('08a76ab4', component.options)
    } else {
      api.reload('08a76ab4', component.options)
    }
    module.hot.accept("./SaleHistoryEventSentInfo.vue?vue&type=template&id=08a76ab4&scoped=true", function () {
      api.rerender('08a76ab4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/sales/SaleHistoryEventSentInfo.vue"
export default component.exports